import { Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PreloaderService } from '@core';
import { DataService } from '@core/bootstrap/data.service';
import { LocalStorage } from '@core/bootstrap/localstorage.service';
import { environment } from '@env/environment';
import { AlertService } from '@shared/components/alert/alert.service';
import { ConfirmationDialog } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { LanguagePipe } from '@shared/pipes/language.pipe';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { OnDestroy } from '@angular/core';
declare var $:any;
interface list {
  id?: number;
  files_level_groups_id: string,
  group_key: string,
  groupname: string,
  level_key: string,
  levelname: string,
}
@Component({
  selector: 'app-files-level-groups',
  templateUrl: './files-level-groups.component.html',
  styleUrls: ['./files-level-groups.component.scss']
})
export class FilesLevelGroupsComponent implements OnInit,OnDestroy {
  modalRefA: BsModalRef;
  tabledatas: list[];
  form:FormGroup;
  @Output() actionEvent             = new EventEmitter<any>();
  collectionSize                    = 0;
  page                              = 1;
  pageSize                          = 10;
  searchKey                         = "";
  nodata: string                    = this.lang.transform('lang_loading');
  admin                             = JSON.parse(this.ls.getItem('is_admin'));
  wholeData:any                     = [];
  tabledata:any                     = [];
  groups:any                        = [];
  levels:any                        = [];
  constructor(public ds:DataService, public lang:LanguagePipe, public ls:LocalStorage, public fb:FormBuilder, public spinner:PreloaderService, public alert:AlertService, public dialog:MatDialog, public modalService: BsModalService) { }
  ngOnInit(): void {
    this.spinner.show();
    this.get_group_levels();
    this.get_file_level_groups();
    this.form = new FormGroup({
      files_level_groups_id   : new FormControl(''),
      level_key               : new FormControl('', [Validators.required]),
      group_key               : new FormControl('', [Validators.required]),
    });
  }
  private subscriptions = new Subscription();
	ngOnDestroy(): void {
	  this.subscriptions.unsubscribe();
	}
  public get_group_levels() {
    this.subscriptions.add(
        this.ds.forkJoin(['ugroup_lists', 'lflevel'], []).subscribe(res => {
          if(res[0].status) {
            this.groups = res[0].records;
          }
          if(res[1].status) {
            this.levels = res[1].records;
          }
        })			
      )

  }
  //add, edit model
  public openModalA(template: TemplateRef<any>) {
    this.modalRefA = this.modalService.show(template, environment.modelconfig);
  }
  public get_file_level_groups() {
    let param = new FormData();
    param.append('search_key', this.searchKey);
    this.subscriptions.add(
        this.ds.getActionByUrl(this.ds.formData2string(param), 'lfglevel').subscribe(res=>{
          this.spinner.hide();
          if(res.status) {
            this.wholeData      = res.records;
            this.tabledatas     = res.records;
            this.collectionSize = res.records.length;
            this.build_table_data();
          } else {
            this.wholeData = [];
            this.nodata = res.error;
          }
        }, error => {
          this.spinner.hide();
          this.wholeData = [];
          this.nodata = (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error');
        }) 			
      )

  }
  public build_table_data() {
    this.tabledata = this.tabledatas.map((list, i) => ({ id: i + 1, ...list })).slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
  public edit_file_level_group_data(row) {
    this.alert.clear();
    this.form.patchValue(row);
  }
  public submit() {
    this.spinner.show();
    if(this.form.get('files_level_groups_id').value) {
      this.subscriptions.add(
          this.ds.putActionByUrl(this.ds.formData2string(this.ds.json2formdata(this.form.value)), 'ufglevel/' + this.form.get('files_level_groups_id').value).subscribe(res=> {
            this.spinner.hide();
            if(res.status) {
              this.get_file_level_groups();
              this.form.reset();
              this.actionEvent.emit('');
              this.alert.success(res.msg);
              setTimeout(() => {
                this.modalRefA.hide();
              }, 500);
            } else {
              this.alert.error(res.error);
            }
          }, error => {
            this.spinner.hide();
            this.alert.error((error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
          })			
        )

    } else {
      this.subscriptions.add(
          this.ds.postActionByUrl(this.ds.json2formdata(this.form.value), 'cfglevel').subscribe(res=> {
            this.spinner.hide();
            if(res.status) {
              this.get_file_level_groups();
              this.form.reset();
              this.actionEvent.emit('');
              this.alert.success(res.msg);
              setTimeout(() => {
                this.modalRefA.hide();
              }, 1000);
            } else {
              this.alert.error(res.error);
            }
          }, error => {
            this.spinner.hide();
            this.alert.error((error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
          })			
        )

    }
  }
  public checkallItemsfGLevl(event) {
    if (event.target.checked) {
      $(".appfilelevelgroups .eachItemfGLevl").prop("checked", true);
      $(".appfilelevelgroups .makeback").addClass("bground");
      $(".appfilelevelgroups .deleteIconDiv").show();
    } else {
      $(".appfilelevelgroups .eachItemfGLevl").prop("checked", false);
      $(".appfilelevelgroups .makeback").removeClass("bground");
      $(".appfilelevelgroups .deleteIconDiv").hide();
    }
  }
  public checkeachItemfGLevl(event) {
    if (event.target.checked) {
      const val = event.target.value;
      $(".appfilelevelgroups .removerow" + val).addClass("bground");
    } else {
      const val = event.target.value;
      $(".appfilelevelgroups .removerow" + val).removeClass("bground");
    }
    const checkedtotal = [];
    $(".appfilelevelgroups .eachItemfGLevl:checked").each(function () {
      checkedtotal.push($(this).val());
    });
    const totalrow = [];
    $(".appfilelevelgroups .eachItemfGLevl").each(function () {
      totalrow.push($(this).val());
    });
    if (checkedtotal.length > 0) {
      $(".appfilelevelgroups .deleteIconDiv").show();
    } else {
      $(".appfilelevelgroups .deleteIconDiv").hide();
    }
    if (checkedtotal.length === totalrow.length) {
      $(".appfilelevelgroups #allItemsfGLevl").prop("checked", true);
    } else {
      $(".appfilelevelgroups #allItemsfGLevl").prop("checked", false);
    }
  }
  public deleteBulkDatafGLevl() {
    const checkedtotal = [];
    $(".appfilelevelgroups .eachItemfGLevl:checked").each(function () {
      checkedtotal.push($(this).val());
    });
    if (checkedtotal.length > 0) {
      const dialogRef = this.dialog.open(ConfirmationDialog,{
        disableClose: true,
        width:'400px',
        data:{
          title: this.lang.transform('lang_confirmation'),
          message: this.lang.transform('lang_are_you_sure'),          
        }
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.spinner.show()
          this.subscriptions.add(
            this.ds.deleteActionByUrl(checkedtotal, 'dfglevel').subscribe(
                (data) => {
                  this.spinner.hide()
                  if (data.status) {
                    this.actionEvent.emit('');
                    this.get_file_level_groups();
                    $(".appfilelevelgroups #allItemsfGLevl").prop("checked", false);
                    $(".appfilelevelgroups .deleteIconDiv").hide();
                    this.ds.dialogf('', data.msg);
                  } else {
                    this.ds.dialogf('', data.error);
                  }
                },
                (error) => {
                  this.ds.dialogf('', (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
                  this.spinner.hide()
                }
              )			
            )
 
        }
      });
    } else {
      this.ds.dialogf();
    }
  }
}
